// @flow
import type { PromoCampaign } from '../constants';

/**
 * Campaña «BlackPlus»: código BLACKPLUS26, 20% en los dos planes, del 1 al 30 de noviembre de 2026
 * (Black Friday y Cyber Monday).
 *
 * Solo datos, igual que verano: la maqueta y los textos están en views/BlackPlus.
 */
export const blackplus: PromoCampaign = {
  id: 'blackplus',
  code: 'BLACKPLUS26',
  discount: 20,
  // Hasta este día (hora de España) la URL sirve el checkout de siempre aunque el ajuste de dashboard2
  // esté encendido; ese día se enciende sola salvo que el ajuste la apague. En pre-release no cuenta,
  // para poder revisarla antes del lanzamiento.
  startIso: '2026-11-01',
  endIso: '2026-11-30',
  setting: 'plus-promo-blackplus',
  ga4: { promotionName: 'blackplus_2026', label: 'blackplus', pageId: 'blackplus' }
};
